<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('notice.message') }}
      </div>
    </div>
    <div class="msg_num">
      <!-- <div class="all_msg"><span>{{data.ok_read_num}}</span>{{$t('notice.unRead')}}</div>
			<div class="read">全部标为已读</div> -->
    </div>
    <div class="msg_box">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-for="item in data.list"
        v-if="!empty"
        class="item"
        @click="$router.push('/notice/'+item.id)"
      >
        <div class="tit">
          <p class="tips van-ellipsis">
            <span
              v-if="item['status']==0"
              style="color: red;"
            >
              <van-icon
                name="warning-o"
                size="16"
                color="red"
              />
            </span>
            {{ item[title] }}
          </p>
          <p class="time">
            {{ item.add_time }}
          </p>
        </div>
        <div
          class="content van-multi-ellipsis--l2"
          v-html="item[content]"
        />
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Login",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				empty:false,
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/notice').then((r) => {
					this.data = r.data;
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	
	.msg_num{
		width:100%;
		height:20px;
		display: flex;
		justify-content: space-between;
		padding: 0 11px 0 20px;
		align-items: center;
		overflow: hidden;
		.all_msg{
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			span{
				color: #F03041;
			}
		}
		.read{
			font-size: 12px;
			color: #3D96FF;
		}
	}
	.msg_box{
		width: 96%;
		margin-left: 2%;
		border-radius: 5px;
		background:rgba(255,255,255,1);
		padding: 0 13px 0 20px;
		box-shadow:0px 2px 9px 2px rgba(160,160,160,0.15);
		
		.item{
			padding: 10px 0 13px 0;
			border-bottom: 1px solid #ECECEC;
			&:last-of-type{
				border-bottom: none;
			}
			.tit{
				display: flex;
				justify-content: space-between;
				align-items: center;
				.tips{
					font-size: 14px;
                    flex: 1;
					line-height: 20px;
					color: rgba(0,0,0,.8);
					font-weight: bold;
				}
				.time{
                    flex: 1;
                    text-align: right;
					font-size: 12px;
					color: rgba(0,0,0,.6);
				}
			}
			.content{
				height: 36px;
				margin-top: 2px;
				line-height: 18px;
				font-size: 13px;
				color: rgba(0,0,0,.6);
			}
		}
	}

	/* Scoped announcement-list styling, aligned with the account-center teal palette. */
	.letter_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(180deg, #f3f9f8, #eaf5f3); color: #173f44; }
	.red_top_bg { height: 54px; background: rgba(255, 255, 255, .97); border-bottom: 1px solid #c7e0dd; box-shadow: 0 4px 14px rgba(7, 69, 75, .07); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #073f47; }
	.msg_num { height: 14px; padding: 0; }.msg_box { width: auto; margin: 14px; padding: 0 14px; border: 1px solid #c9e1de; border-radius: 15px; background: rgba(255, 255, 255, .96); box-shadow: 0 10px 24px rgba(12, 75, 79, .08); }.msg_box .item { padding: 15px 0; border-bottom-color: #dcebea; }.msg_box .item .tit .tips { color: #173f44; line-height: 22px; }.msg_box .item .tit .time { color: #718c8f; }.msg_box .item .content { height: 40px; margin-top: 5px; color: #527276; line-height: 20px; }.msg_box .item .tit .tips /deep/ .van-icon { color: #0c7b83 !important; }
	/deep/ .van-empty { background: rgba(255, 255, 255, .96); color: #527276; }
</style>
